import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-24">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-12">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="投稿常见问题"
              title="投稿前，先看这几个问题"
              desc="我们把投稿人问得最多的疑问整理在这里。如果还有不清楚的地方，欢迎直接联系编辑组。"
            />
            <div className="reveal mt-7 bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
              <p className="text-sm text-foreground-600 leading-relaxed">
                仍不确定自己的材料是否符合要求？把大概情况发给我们，编辑组会判断是否值得进一步核验。
              </p>
              <a
                href="#contact"
                className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                联系编辑组
              </a>
            </div>
          </div>

          <div className="lg:col-span-3 flex flex-col gap-3">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="reveal bg-background-50 border border-background-200 rounded-lg overflow-hidden"
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? null : index)}
                      aria-expanded={open}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 md:py-5 text-left cursor-pointer"
                    >
                      <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {item.q}
                      </span>
                      <span
                        className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <div className="px-5 pb-5 -mt-1 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}